const data = {

  topSection: {
    headingText: "Elevate your property with",
    highlightedText: "stunning ",
    subText: "Discover unparalleled creativity and reliable service with NatureCraft",
    headingText2: "landscapes",
    video: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fdesign-ideas%2FLandscape%2Fvideo.mp4?alt=media&token=6926e7f9-e87b-49e6-ac0a-8085fa34382f"
  },

  features: [
    {
      title: 'Façade design and renovation',
      image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fdesign-ideas%2FLandscape%2Fkey-features%2F1.png?alt=media&token=74eb39ca-3482-4b72-a56e-ed24c26beb96"
    },
    {
      title: 'Energy-efficient solutions',
      image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fdesign-ideas%2FLandscape%2Fkey-features%2F2.png?alt=media&token=22fa6f19-cb3e-4455-bc3b-9734797828a1"
    },
    {
      title: 'Structural enhancements',
      image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fdesign-ideas%2FLandscape%2Fkey-features%2F3.png?alt=media&token=1df81347-22ef-48d4-9cfd-3d99f2003b8f"
    },
    {
      title: 'Aesthetic improvement plans',
      image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fdesign-ideas%2FLandscape%2Fkey-features%2F4.png?alt=media&token=7aac7edb-3043-40f5-bcd5-1eec58a0f3a1"
    },
  ],

  numbers: [
    { number: 50, label: 'Interior Experts', symbol: '+', duration: 2500 },
    { number: 60, label: 'Location Served', symbol: '+', duration: 2500 },
    { number: 1000, label: 'Happy Clients', symbol: '+', duration: 2500 },
  ],

  stepsData: [
    {
      title: 'Client Meeting',
      description: 'Understand exterior design requirements.',
      image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fdesign-ideas%2FLandscape%2Fhow-it-works%2F1.png?alt=media&token=8a5ed18d-774f-47c6-92df-75580b9bc9e5"
    },
    {
      title: 'Site Evaluation',
      description: 'Examine site for exterior possibilities.',
      image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fdesign-ideas%2FLandscape%2Fhow-it-works%2F2.png?alt=media&token=8cd9f9cf-53fc-48bf-8a42-99f945e4c0f6"
    },
    {
      title: 'Design Proposal',
      description: 'Present exterior design concepts.',
      image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fdesign-ideas%2FLandscape%2Fhow-it-works%2F3.png?alt=media&token=3215d278-c2b3-4664-952f-0115b049893f"
    },
    {
      title: 'Material Selection',
      description: 'Choose appropriate materials and finishes.',
      image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fdesign-ideas%2FLandscape%2Fhow-it-works%2F4.png?alt=media&token=bbeb08aa-6954-42ee-8abe-bf59c1276129"
    },
    {
      title: 'Execution',
      description: 'Implement exterior design plan.',
      image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fdesign-ideas%2FLandscape%2Fhow-it-works%2F5.png?alt=media&token=a7df36dc-2bba-42c4-adcc-d478dc73ba6f"
    },
    {
      title: 'Final Walkthrough',
      description: 'Review completed exterior work with client.',
      image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fdesign-ideas%2FLandscape%2Fhow-it-works%2F6.png?alt=media&token=2ea05f7b-f8b6-435f-a190-758f1bdac8ae"
    },
  ],

  stepData: [
    {
      number:1,
      title: 'Client Meeting',
      description: 'Understand exterior design requirements.',
      icon: require('../assets/design-ideas/Landscape/how-it-works/1.png')
    },
    {
      number:2,
      title: 'Site Evaluation',
      description: 'Examine site for exterior possibilities.',
      icon: require('../assets/design-ideas/Landscape/how-it-works/2.png')
    },
    {
      number:3,
      title: 'Design Proposal',
      description: 'Present exterior design concepts.',
      icon: require('../assets/design-ideas/Landscape/how-it-works/3.png')
    },
    {
      number:4,
      title: 'Material Selection',
      description: 'Choose appropriate materials and finishes.',
      icon: require('../assets/design-ideas/Landscape/how-it-works/4.png')
    },
    {
      number:5,
      title: 'Execution',
      description: 'Implement exterior design plan.',
      icon: require('../assets/design-ideas/Landscape/how-it-works/5.png')
    },
    {
      number:6,
      title: 'Final Walkthrough',
      description: 'Review completed exterior work with client.',
      icon: require('../assets/design-ideas/Landscape/how-it-works/6.png')
    },
  ],

  faqs: [
    {
      question: 'What does exterior design include?',
      answer:
        'Exterior design includes the planning and styling of the outer appearance of a building, involving elements like facades, color schemes, landscaping, and material selection.',
    },
    {
      question: 'Can you help with both residential and commercial exterior designs?',
      answer:
        'Yes, we offer exterior design services for both residential and commercial properties.',
    },
    {
      question: 'How do you approach the design of a building’s exterior?',
      answer:
        'We begin with a consultation to understand your preferences and needs, considering sustainability, materials, and landscaping for a cohesive design.',
    },
    {
      question: 'Can you incorporate eco-friendly elements into exterior designs?',
      answer:
        'Yes, we can integrate eco-friendly elements like energy-efficient lighting and sustainable materials into your design.',
    },
    {
      question: 'How long does the exterior design process take?',
      answer:
        'The duration depends on the scope of the project. We provide a timeline during consultation.',
    },
    {
      question: 'Do you offer 3D renderings for exterior designs?',
      answer:
        'Yes, 3D renderings are provided to help visualize the final design before construction.',
    },
    {
      question: 'What factors should I consider when choosing an exterior design?',
      answer:
        'Consider factors like architectural style, local climate, maintenance, energy efficiency, and landscaping.',
    },
    {
      question: 'How do I get started with your exterior design services?',
      answer:
        'Contact us for a consultation, and we’ll assess your property and provide design ideas.',
    },
  ],
  reviews: [
    {
      review: "Outstanding design. They captured our vision with precision and efficiency. Highly satisfied!",
      name: "Mitali Sinha",
      avatar: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Ftestimonials%2Fmitali-sinha.jpeg?alt=media&token=9c952e12-04e5-454c-a2d7-3f8796706891",
      rating: 5
    },
    {
      review: "Transformed our space beautifully. A seamless process from start to finish. Highly recommended.",
      name: "P. Gowda",
      avatar: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Ftestimonials%2Fp-gowda.jpeg?alt=media&token=cd8de94e-73a2-4a14-92c7-7b1e3ae79d48",
      rating: 4
    },
    {
      review: "They listened, they delivered. Impressed by their service.",
      name: "Nitin Prajapat",
      avatar: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Ftestimonials%2Fnitin-prajapat.jpeg?alt=media&token=f783369b-6c53-4c80-82eb-8a86e89debef",
      rating: 4
    },
    {
      review: "Fantastic architecture design & affordable.",
      name: "Snehal Raj",
      avatar: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Ftestimonials%2Fsnehal-raj.jpeg?alt=media&token=8937fcad-9cff-4196-9bde-9b114eea6990",
      rating: 5
    },
  ],
  review: [
    {
      quote: "Outstanding design. They captured our vision with precision and efficiency. Highly satisfied!",
      name: "Mitali Sinha",
      avatar: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Ftestimonials%2Fmitali-sinha.jpeg?alt=media&token=9c952e12-04e5-454c-a2d7-3f8796706891",
      rating: 5
    },
    {
      quote: "Transformed our space beautifully. A seamless process from start to finish. Highly recommended.",
      name: "P. Gowda",
      avatar: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Ftestimonials%2Fp-gowda.jpeg?alt=media&token=cd8de94e-73a2-4a14-92c7-7b1e3ae79d48",
      rating: 4
    },
    {
      quote: "They listened, they delivered. Impressed by their service.",
      name: "Nitin Prajapat",
      avatar: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Ftestimonials%2Fnitin-prajapat.jpeg?alt=media&token=f783369b-6c53-4c80-82eb-8a86e89debef",
      rating: 4
    },
    {
      quote: "Fantastic architecture design & affordable.",
      name: "Snehal Raj",
      avatar: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Ftestimonials%2Fsnehal-raj.jpeg?alt=media&token=8937fcad-9cff-4196-9bde-9b114eea6990",
      rating: 5
    },
  ]
};

export default data;
